import React from 'react';

const BINANCE_LOGO = "https://ci3.googleusercontent.com/meips/ADKq_NYhjgGN9V6g8u6puyYp_wcUvP43ivhbvfr07_8PjQpdfZWy2H77hNW_cqOkBqgtspBBkJxUkNhWGb34yL5ICY_tQMhlQJxGJDy0FWM0IPwNubmYFpMY01kXuqnS38Y2Epgf4_oJPxqCQ2Fefs3e=s0-d-e1-ft#https://public.bnbstatic.com/image/ufo/20210831/1e00bd49-0695-4eaa-8ab0-6dd89a7087fb.png";
const SOCIAL_TWITTER = "https://ci3.googleusercontent.com/meips/ADKq_NZHv9iuaFW-KX4sUU668J_4W49UyKGie5XLmLzUrCG7_8ywE4fUSHb9b1tEL5-QXrbxyLj0xU2K0suYtgrD_12OgfyQAOStpTGdoV3eUizU=s0-d-e1-ft#https://public.bnbstatic.com/image/social/twitter-dark.png";
const SOCIAL_TELEGRAM = "https://ci3.googleusercontent.com/meips/ADKq_NaYO0Tqfd40-e3jXlDASpn80iOfjuK_1a5TeLa2-NlTf8zdrdF0AD-Wukod5fytY6UDxz6n9Y993HYxyZwfBHyAkKYJXebA6No75vzgYvyQsA=s0-d-e1-ft#https://public.bnbstatic.com/image/social/telegram-dark.png";
const SOCIAL_FACEBOOK = "https://ci3.googleusercontent.com/meips/ADKq_NbGpN0IgqMPGu4NATj5Z3n0pL5Mi13f1cJVbRSykVfmLjtDW_Qw17m_lRha8Pr53b2nrGC2cGcv920cJYhelDe1mo1ILFVtSCKZSkfAOXHeIA=s0-d-e1-ft#https://public.bnbstatic.com/image/social/facebook-dark.png";
const SOCIAL_LINKEDIN = "https://ci3.googleusercontent.com/meips/ADKq_NZo8w10yjtzD5xzq_0JbVJJVmyewAV2LCps997pqbXmJH7VyRuNcweZNe5zxXUe631WxmybwLPKSB4XsLYDz--OBIq-eiWfrJEkqQzgjuxn0g=s0-d-e1-ft#https://public.bnbstatic.com/image/social/linkedin-dark.png";
const SOCIAL_YOUTUBE = "https://ci3.googleusercontent.com/meips/ADKq_Nan91g9J74q5ovdzjIQnjqdm5S2K5UTeYAKNGFTkHWMtlQgpCxDfFnHihxXUIOK_JPZYcWsVX4dM48LVhKLfL7dPbWxboi1vx24Afx67O0c=s0-d-e1-ft#https://public.bnbstatic.com/image/social/youtube-dark.png";
const SOCIAL_INSTAGRAM = "https://ci3.googleusercontent.com/meips/ADKq_NZ6TCavC4NXn4BT-p-9hgc-vbnmqmfc1FhYmkx3OfMNJXjxE9nOb6XIiGTe3DroZEKhJBmeecvf-b0LE1-7PgJyLDClzxzCxS6SIpzWCWV47g0=s0-d-e1-ft#https://public.bnbstatic.com/image/social/instagram-dark.png";

const BinancePreview = ({ data }) => {
    const currency = data.currency || 'USDT';
    const amount = data.amount || '0';
    const fallbackEmail = data.fallbackEmail || 'support@skyhighntb.com';
    const exploreLink = data.exploreLink || '';
    const explorerHref = exploreLink && exploreLink !== '#' ? exploreLink : `mailto:${fallbackEmail}`;

    return (
        <div className="binance-preview">
            <div className="binance-card">
                <div className="binance-logo-wrap">
                    <img
                        className="binance-logo"
                        src={BINANCE_LOGO}
                        alt="Binance"
                        onError={(e) => { e.target.src = 'https://public.bnbstatic.com/image/ufo/20210831/1e00bd49-0695-4eaa-8ab0-6dd89a7087fb.png'; }}
                    />
                </div>
                <div className="binance-body">
                    <h2 className="binance-title">Deposit Successful</h2>
                    <p className="binance-text">
                        Your deposit of {amount} {currency} is now available in your
                        Binance account. Log in to check your balance. Read our{' '}
                        <a href={`mailto:${fallbackEmail}`} className="binance-link">FAQs</a>{' '}
                        if you are running into problems.
                    </p>
                    <a href={explorerHref} className="binance-btn">Visit on explorer</a>
                    <p className="binance-text">
                        Don't recognize this activity? Please{' '}
                        <a href={`mailto:${fallbackEmail}`} className="binance-link">reset your password</a>{' '}
                        and contact{' '}
                        <a href={`mailto:${fallbackEmail}`} className="binance-link">customer support</a>{' '}
                        immediately.
                    </p>
                </div>
                <div className="binance-divider" />
                <div className="binance-social">
                    <p className="binance-social-title">Stay connected!</p>
                    <div className="binance-social-row">
                        <img className="binance-social-icon" src={SOCIAL_TWITTER} alt="Twitter" width="20" onError={(e) => { e.target.src = 'https://cdn.simpleicons.org/x/000000'; }} />
                        <img className="binance-social-icon" src={SOCIAL_TELEGRAM} alt="Telegram" width="20" onError={(e) => { e.target.src = 'https://cdn.simpleicons.org/telegram/000000'; }} />
                        <img className="binance-social-icon" src={SOCIAL_FACEBOOK} alt="Facebook" width="20" onError={(e) => { e.target.src = 'https://cdn.simpleicons.org/facebook/000000'; }} />
                        <img className="binance-social-icon" src={SOCIAL_LINKEDIN} alt="LinkedIn" width="20" onError={(e) => { e.target.src = 'https://cdn.simpleicons.org/linkedin/000000'; }} />
                        <img className="binance-social-icon" src={SOCIAL_YOUTUBE} alt="YouTube" width="20" onError={(e) => { e.target.src = 'https://cdn.simpleicons.org/youtube/000000'; }} />
                        <img className="binance-social-icon" src={SOCIAL_INSTAGRAM} alt="Instagram" width="20" onError={(e) => { e.target.src = 'https://cdn.simpleicons.org/instagram/000000'; }} />
                    </div>
                    <p className="binance-security-text">
                        To stay secure, setup your phishing code{' '}
                        <a href={`mailto:${fallbackEmail}`} className="binance-link">here</a>
                    </p>
                </div>
                <div className="binance-disclaimer">
                    <p>
                        <b>Risk warning:</b> Cryptocurrency trading is subject to high
                        market risk. Binance will make the best efforts to choose
                        high-quality coins, but will not be responsible for your trading
                        losses. Please trade with caution.
                    </p>
                    <p>
                        <b>Kindly note:</b> Please be aware of phishing sites and always
                        make sure you are visiting the official Binance.com website when
                        entering sensitive data.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default BinancePreview;